export enum StorageKey {
    BASICS = 'portfolio-data-basics',
    STORIES = 'portfolio-data-stories',
    SKILLS = 'portfolio-data-skills',
    EXPERIENCES = 'portfolio-data-experiences',
    CV = 'porfolio-file-cv',
    PICTURE = 'portfolio-file-profile-picture'
}
